export const ALERT_SHOW_INTERVAL = 30000;
